import React from 'react'
import { connect } from 'react-redux'

import { getColor } from 'modules/org/selectors'

import arrowSrc from './arrow.svg'
import DynamicSchedulingCard from 'layouts/DynamicSchedulingCard'

import './style.css'

const MeetingsBookedPreview = ({ isCalendarSeat, color }) => (
  <div className="meetings-booked-preview">
    <div className="meetings-booked-preview-message">
      <img className="meetings-booked-preview-arrow" src={arrowSrc} alt="" />
      <p>
        {isCalendarSeat
          ? 'This is how a teammate can book a meeting for you!'
          : 'Thisi s what booking a meeting looks like!'}
      </p>
    </div>
    <div className="meetings-booked-preview-container">
      <div className="meetings-booked-preview-content-border" />
      <div
        className="meetings-booked-preview-content-message message-1"
        style={{ backgroundColor: `#${color || '#1159a6'}` }}
      >
        We&rsquo;re about 300 employees.
      </div>
      <div className="meetings-booked-preview-content-teammate">John Doe</div>
      <div className="meetings-booked-preview-content-message message-2">
        Wow, you sound like a great fit!
      </div>
      <div className="meetings-booked-preview-content-message message-3">
        Feel free to grab some time on my teammate&rsquo;s calendar to talk more!
      </div>
      <DynamicSchedulingCard className="meetings-booked-preview-content-card" showEmptyValues={false} />
    </div>
  </div>
)

const mapStateToProps = state => ({
  color: getColor(state),
})

export default connect(mapStateToProps)(MeetingsBookedPreview)



// WEBPACK FOOTER //
// ./src/layouts/MeetingsBookedPreview/index.js